module.exports = __webpack_public_path__ + "img/Jesus-Christ-Tattoo-Design-by-ollievenegas-728x728.jpg";